// MOBD-66: acciones (CtaAction) del contrato de bloqueo de usuario del backend.
//
// El backend renderiza el texto del bloqueo (title/reason/solution/cta.label); aquí solo se
// normaliza el nombre de la acción para poder mapearlo a una ruta/handler del operador. El
// conjunto de valores es EXACTO y cerrado: cualquier valor fuera de la lista (o null / no-string)
// se degrada a NONE, para que una acción nueva del backend nunca rompa la UI del operador.
export const CtaAction = {
    ACCEPT_TERMS: 'ACCEPT_TERMS',
    GO_TO_PROFILE_BILLING: 'GO_TO_PROFILE_BILLING',
    GO_TO_DOCUMENTATION: 'GO_TO_DOCUMENTATION',
    UPLOAD_KYC: 'UPLOAD_KYC',
    REGULARIZE_PAYMENT: 'REGULARIZE_PAYMENT',
    ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
    CHANGE_PAYMENT_METHOD: 'CHANGE_PAYMENT_METHOD',
    CONTACT_SUPPORT: 'CONTACT_SUPPORT',
    RETRY: 'RETRY',
    NONE: 'NONE',
}

const KNOWN = new Set(Object.values(CtaAction))

// Devuelve la acción verbatim si es una de las conocidas; en cualquier otro caso, NONE.
export function ctaActionFromString(raw) {
    return typeof raw === 'string' && KNOWN.has(raw) ? raw : CtaAction.NONE
}
